/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersTenantResponseDto } from '../../models/users-tenant-response-dto';

export interface TenantsControllerFindAll$Params {
}

export function tenantsControllerFindAll(http: HttpClient, rootUrl: string, params?: TenantsControllerFindAll$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersTenantResponseDto>>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<Array<UsersTenantResponseDto>>;
    })
  );
}

tenantsControllerFindAll.PATH = '/o2-users/tenants';
